import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MUICardContent(theme: Theme): Components['MuiCardContent'] {
  return {
    styleOverrides: {
      root: {
        padding: theme.spacing(3),
      },
    },
  };
}
